export const AD_POSITION_FACTOR = 4;
export const canShow = (position: number): boolean => {
  return (position + 1) % AD_POSITION_FACTOR === 0;
};
